import type { ReactNode } from 'react';
import { Flex } from 'ui';

type P = {
  children: ReactNode;
  onClick: () => void;
};

const SearchBox = ({ children, onClick }: P) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- TODO: fix
  <div className="global-search-box" onClick={onClick}>
    <Flex className="global-search-box__wrapper" flex="1">
      {children}
    </Flex>
  </div>
);

export default SearchBox;
